import { render, staticRenderFns } from "./questionFeedback.vue?vue&type=template&id=dd471af0&scoped=true"
import script from "./questionFeedback.vue?vue&type=script&lang=js"
export * from "./questionFeedback.vue?vue&type=script&lang=js"
import style0 from "./questionFeedback.vue?vue&type=style&index=0&id=dd471af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd471af0",
  null
  
)

export default component.exports